import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { appState } from "$reducers";
import { useWMSConfigQuery } from "./useWMSConfigQuery";

const useWMSConfig = () => {
  const { filter } = useSelector(appState);
  const { data: wmsConfigs = [], isLoading: wmsConfigLoader } =
    useWMSConfigQuery();
  const [wmsConfigList, setWMSConfigList] = useState<any[]>(wmsConfigs || []);
  const [refreshPageTable, setRefreshPageTable] = useState<any>(false);

  useEffect(() => {
    setWMSConfigList(wmsConfigs);
  }, [wmsConfigs]);

  return {
    filter,
    wmsConfigList,
    loading: wmsConfigLoader,
    refreshPageTable,
    setRefreshPageTable,
  };
};

export default useWMSConfig;
